import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-offers-page',
  templateUrl: './offers-page.component.html',
  styleUrls: ['./offers-page.component.scss'],
})
export class OffersPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
